import { EQUALS, LIKE } from "./GraphQLFilterTypes";

const toSnakeCaseFilter = (str) => {
    const allOperators = [EQUALS, LIKE];

    const split_str = str.split(";");
    let filterStr = "";

    split_str.map((filter) => {
        const operator = allOperators.find((op) => filter.includes(op));
        const filterExprVal = filter.split(operator);
        filterStr += filterExprVal[0].replace(/[A-Z]/g, (m) => "_" + m.toLowerCase()) + operator + filterExprVal[1];
        filterStr = !filterStr.endsWith(";") ? filterStr + ";" : filterStr;
        filterStr = sanitizeFilter(filterStr);
    });

    return filterStr;
};

const toSnakeCaseSort = (str) => {
    return str.replace(/[A-Z]/g, (m) => "_" + m.toLowerCase());
};

export const cleanStringAndUnaccent = (input) => {
    /**
     * Removes symbols from string (except - and ').
     */
    input = input.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    input = input.replace(/[^\w\-\s\'\'.]/g, "");

    return input.replace(/\s\s+/g, " "); /** Remove extra spaces. */
};

export const cleanStringForFTS = (input) => {
    input = input.normalize("NFD").replace(/[\u0300-\u036f]/g, ""); /** Unaccent input. */
    
    return input
        .replace(/[^A-Za-z0-9 /]+/g, " ")
        .replace(/\s+/g, " ")
        .trim();
};

export const buildGraphQLQueryParams = (
    schemaName,
    filter,
    sortBy,
    offset,
    limit,
    colsStr,
    queryName = "myQuery",
    q = "",
    additionalParams = ""
) => {
    if (additionalParams) {
        additionalParams = ", " + additionalParams;
    }
    return `query ${queryName}{${schemaName}(filter: "${filter}", sortBy: "${sortBy}", offset: ${offset}, limit: ${limit}, q:"${q}"${additionalParams}){
				items {
					${colsStr}
				}
				count
				limit
				offset
				totalCount
			}
		}
	`;
};

export const toGraphQLFormat = (filters) => {
    const formattedFilter = [];
    filters.forEach((filter) => {
        if (filter.endsWith(";")) {
            filter = filter.slice(0, -1);
        }
        filter = toSnakeCaseFilter(filter);

        formattedFilter.push(filter);
    });

    return formattedFilter.join("");
};

export const arrayToFilterStr = (filters) => {
    return filters.join(";");
};

export const toGraphQLSortFormat = (sort, isMultiple) => {
    isMultiple = isMultiple || false;
    const formattedSort = [];

    sort.forEach((sort) => {
        if (sort.endsWith(";")) {
            sort = sort.slice(0, -1);
        }
        sort = toSnakeCaseSort(sort);
        formattedSort.push(sort);
    });
    return isMultiple ? formattedSort.join(";") : formattedSort;
};

export const formatMultipleSort = (sort) => {
    return sort.join(";");
};
export const formatMultipleFilters = (filter) => {
    /**
     * This function will help us build =in= operator filters.
     * When we loop through our filters in our parent component,
     * we pass them to this function. If we detect multiple filters for one
     * column (ex: follows_ups.priority==URGENT;follow_ups.priority==48H), we will rebuild the filter
     * string to: follow_ups.priority=in=['URGENT', '48H']
     */
    const filters = filter.split(";");
    let singleFilters = [];

    const filterKeys = [
        ...new Set(
            filters
                .map((filter) => {
                    const equalsOperatorExpr = filter.split(EQUALS);
                    const likeOperatorExpr = filter.split(LIKE);
                    return equalsOperatorExpr.length > 1 ? equalsOperatorExpr[0] : likeOperatorExpr[0];
                })
                .filter((f) => f)
        ),
    ];

    const filtersDict = filterKeys.reduce((dict, filter) => {
        dict[filter] = [];
        return dict;
    }, {});

    for (let i = 0; i < filters.length; i++) {
        const equalsOperatorExpr = filters[i].split(EQUALS);
        const likeOperatorExpr = filters[i].split(LIKE);
        const filterKey = equalsOperatorExpr.length > 1 ? equalsOperatorExpr[0] : likeOperatorExpr[0];
        const expr = equalsOperatorExpr.length > 1 ? equalsOperatorExpr : likeOperatorExpr;
        if ((filterKey && equalsOperatorExpr.length > 1) || (filterKey && likeOperatorExpr.length > 1)) {
            /** Append each filter value to the corresponding filter key, that is in the filters dict. */
            equalsOperatorExpr.length > 1
                ? filtersDict[filterKey].push(expr[1])
                : filtersDict[filterKey].push(`=like=${expr[1]}`);
        } else {
            /**
             * Filters that don't need to be combined are insereted in this array.
             */
            singleFilters.push(filters[i]);
        }
    }

    let groupedFilters = [];

    for (const [k, v] of Object.entries(filtersDict)) {
        if (v.length > 1) {
            groupedFilters.push(
                `${k}=in=[${v.map((val) => {
                    val = val.replace(/'/g, "quote");
                    return `'${val}'`;
                })}]`
            );
        } else {
            /** We know that all filters in the filtersDict have the operator == */
            if (v[0].includes(LIKE)) {
                singleFilters.push(`${k}${v[0]}`);
            } else {
                singleFilters.push(`${k}==${v}`);
            }
        }
    }

    let formattedFilters = [...singleFilters, ...groupedFilters];
    formattedFilters = formattedFilters.filter((f) => f);

    return formattedFilters.join(";");
};

export const sanitizeFilter = (filter) => {
    filter = filter.replace(/\n/g, "_n_");
    filter = filter.replace(/\t/g, "_t_");
    filter = filter.replace(/\r/g, "_r_");

    return filter;
};



// WEBPACK FOOTER //
// ./src/components/common/GraphQL/GraphQLQueryHelper.js